import React, { useEffect, useState } from "react";
import { Modal, DatePicker, Form, Alert } from "antd";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { Success } from "../../../commons/Messages/Messages";
import { generalErrorAlert } from "../../../commons/GeneralErrorAlert";
import { shiftApi } from "./shiftApi";

// Copies one week's shifts into another week as one-off shifts
const CopyWeekModal = ({ open, onClose, sourceDate, onCopied }) => {
  const { t } = useTranslation("dashboard");
  const [from, setFrom] = useState(null);
  const [to, setTo] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) {
      const week = dayjs(sourceDate).startOf("week");
      setFrom(week);
      setTo(week.add(1, "week"));
    }
  }, [open, sourceDate]);

  const onOk = async () => {
    if (!from || !to || loading) return;
    setLoading(true);
    try {
      const res = await shiftApi.send("post", "/copy-week", {
        from: from.startOf("week").format("YYYY-MM-DD"),
        to: to.startOf("week").format("YYYY-MM-DD")
      });
      Success(res.data.successMessage);
      onCopied && onCopied();
      onClose();
    } catch (err) {
      generalErrorAlert(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={t("Copy week")}
      open={open}
      onOk={onOk}
      onCancel={onClose}
      okText={t("Copy")}
      confirmLoading={loading}
      okButtonProps={{ disabled: !from || !to || from.isSame(to, "week") }}
      destroyOnClose
    >
      <Form layout="vertical">
        <Form.Item label={t("Copy shifts from week")}>
          <DatePicker picker="week" value={from} onChange={setFrom} className="w-100" />
        </Form.Item>
        <Form.Item label={t("Into week")}>
          <DatePicker picker="week" value={to} onChange={setTo} className="w-100" />
        </Form.Item>
      </Form>
      <Alert
        type="info"
        showIcon
        message={t(
          "Each shift day is copied with its staff as a one-off shift. Days a repeating shift already covers in the target week are skipped, so copying twice creates nothing new."
        )}
      />
    </Modal>
  );
};

export default CopyWeekModal;
